module.exports = __webpack_public_path__ + "img/self.dff55d1b.svg";